import { render, staticRenderFns } from "./Users_pay_slips.vue?vue&type=template&id=cbb31458&scoped=true&lang=pug&"
import script from "./Users_pay_slips.vue?vue&type=script&lang=coffee&"
export * from "./Users_pay_slips.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb31458",
  null
  
)

export default component.exports